/** Rutas SIMCE admin embebidas (prefijo /simce). */
export const simceAdminRoutes = {
  path: '/simce',
  component: () => import('@/integrations/simce/SimceAdminShell.vue'),
  meta: { formulario: 'SIMCE Admin', simceAdmin: true, requiresAuth: true },
  children: [
    {
      path: '',
      component: () => import('@simce/layouts/AdminLayout.vue'),
      children: [
        {
          path: '',
          name: 'simce-admin-dashboard',
          component: () => import('@simce/views/DashboardView.vue'),
        },
        {
          path: 'gestion',
          name: 'simce-admin-gestion',
          component: () => import('@simce/views/GestionContenidosView.vue'),
        },
        {
          path: 'gestion/asignaturas',
          name: 'simce-admin-gestion-asignaturas',
          component: () => import('@simce/views/gestion/AsignaturasView.vue'),
        },
        {
          path: 'gestion/ejes',
          name: 'simce-admin-gestion-ejes',
          component: () => import('@simce/views/gestion/EjesView.vue'),
        },
        {
          path: 'gestion/estandares',
          name: 'simce-admin-gestion-estandares',
          component: () => import('@simce/views/gestion/EstandaresView.vue'),
        },
        {
          path: 'gestion/items',
          name: 'simce-admin-gestion-items',
          component: () => import('@simce/views/gestion/ItemsView.vue'),
        },
        {
          path: 'gestion/plantillas',
          name: 'simce-admin-gestion-plantillas',
          component: () => import('@simce/views/gestion/PlantillasEnsayoView.vue'),
        },
        {
          path: 'gestion/tipos-actividad',
          name: 'simce-admin-gestion-tipos-actividad',
          component: () => import('@simce/views/gestion/TiposActividadView.vue'),
        },
        {
          path: 'importaciones',
          name: 'simce-admin-importaciones',
          component: () => import('@simce/views/ImportacionesView.vue'),
        },
        {
          path: 'importaciones/preguntas',
          name: 'simce-admin-importacion-preguntas',
          component: () => import('@simce/views/importaciones/ImportacionPreguntasView.vue'),
        },
        {
          path: 'importaciones/:tipo',
          name: 'simce-admin-importacion-detalle',
          component: () => import('@simce/views/importaciones/ImportacionDetalleView.vue'),
        },
        {
          path: 'sincronizacion',
          name: 'simce-admin-sincronizacion',
          component: () => import('@simce/views/SincronizacionView.vue'),
        },
        {
          path: 'asignacion-cursos-alumnos',
          name: 'simce-admin-asignacion-cursos-alumnos',
          component: () => import('@simce/views/AsignacionCursosAlumnosView.vue'),
        },
        {
          path: 'bienestar/frases-calma',
          name: 'simce-admin-bienestar-frases-calma',
          component: () => import('@simce/views/FrasesCalmaBienestarView.vue'),
        },
        {
          path: 'apoyo/plantillas-mensaje',
          name: 'simce-admin-apoyo-plantillas-mensaje',
          component: () => import('@simce/views/PlantillasApoyoDocenteView.vue'),
        },
        {
          path: 'documentacion',
          name: 'simce-admin-documentacion',
          component: () => import('@simce/views/DocumentacionView.vue'),
        },
      ],
    },
  ],
};
